export default __webpack_public_path__ + "static/media/midle-left-ellipse.63a63e86.svg";